import { create } from "zustand";
import axios from "axios";
import Cookies from "js-cookie";

const orderDeliveryStatusTimeStore = create((set) => ({
  orderDeliveryStatusTime: null,
  isLoading: true,

  createOrderDeliveryStatusTime: async () => {
    const res = await axios.post("/site/create-order-delivery-status-time");

    const { orderDeliveryStatusTime } = orderDeliveryStatusTimeStore.getState();
    const data = orderDeliveryStatusTime ? orderDeliveryStatusTime : [];
    data.push(res.data.orderDeliveryStatusTime);
    set({ orderDeliveryStatusTime: data });
    return res.data.orderDeliveryStatusTime._id;
  },

  fetchOrderDeliveryStatusTime: async () => {
    const res = await axios.get(
      "/site/fetch-all-user-order-delivery-status-time"
    );

    if (res.data.orderDeliveryStatusTime.length) {
      set({ orderDeliveryStatusTime: res.data.orderDeliveryStatusTime });
    }
    set({ isLoading: false });
  },
}));

export default orderDeliveryStatusTimeStore;
